import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';
import appCore from "../core/app";

// Init app
const modAppCore = new appCore();

export class sliderTop{

    // Slider
    slider(elSlider){

        const containers = document.querySelectorAll(elSlider);

        const strClass = modAppCore.rnd(10, modAppCore.rnd.alphaLower);
        let swiperInstances: any = [];

        containers.forEach((element, index) => {
            
            element.classList.add(strClass + "-" + index);

            const paginationSelector = element.dataset.page;

            swiperInstances[index] = new Swiper("." + strClass + "-" + index, {
                modules: [Pagination, Autoplay],
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                observer: true,
                observeParents: true,
                speed: 1200,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: paginationSelector,
                    clickable: true,
                }
            });

        });

    }

}